import { BasketBook, Book } from '../../types/book'

export const addBookToLocalBasket = (book: Book): void => {
  const stringifiedBooks = localStorage.getItem('basket')
  const basketBooks: BasketBook[] = stringifiedBooks
    ? JSON.parse(stringifiedBooks)
    : []

  let updatedBasketBooks = []

  if (!!basketBooks.find((basketBook) => basketBook.book.id! === book.id)) {
    updatedBasketBooks = basketBooks.map((basketBook) =>
      basketBook.book.id! === book.id
        ? { ...basketBook, count: basketBook.count! + 1 }
        : basketBook,
    )
  } else {
    updatedBasketBooks = [...basketBooks, { count: 1, book }]
  }
  localStorage.setItem('basket', JSON.stringify(updatedBasketBooks))
}
